import { useState } from "react"

import { useAdminState, useAdminDispatch, ActionCreators } from "../Context"
import { CompaniesApi } from "../api"
import { toTableData } from "common/helpers/admin-page-func.helper"
import { Form } from "components/pages/users/admin/FormDialog"
import { AdminFormDialog } from "components/partials"
import { UsersApi } from "common/api"
import { useAppSelector, useLocalStorage } from "common/hooks"
import { LocalStorageKey } from "common/helpers"
import { AuthActions } from "store/actions"
import { AdminDeleteDialog } from "components/partials"

const UserFormDialog = props => {
  const { user, DialogProps } = props
  const { params } = useAdminState()
  const { filter, pagination } = params
  const dispatch = useAdminDispatch()

  const [confirmDelete, setConfirmDelete] = useState(false)

  const authActions = AuthActions.useActions()
  const [, setUserInLocalStorage] = useLocalStorage(LocalStorageKey.User)
  const { user: currentUser } = useAppSelector(state => state.auth)

  async function submitCallback(formData) {
    const response = await UsersApi.update(formData)

    if (currentUser && currentUser.id === formData.id) {
      setUserInLocalStorage(response.data)
      authActions.login(response.data)
    }

    updateTable()
  }

  async function updateTable() {
    if (!filter || !pagination) return

    const getResponse = await CompaniesApi.get({
      filter,
      pagination,
      refetch: true
    })
    dispatch(ActionCreators.loaded(toTableData(getResponse)))
  }

  function onClickDelete() {
    setConfirmDelete(true)
  }

  async function onConfirmDelete() {
    if (typeof user.id !== "string") return

    await UsersApi.remove(user.id)
    setConfirmDelete(false)
    updateTable()
  }

  function onExited(node) {
    setConfirmDelete(false)

    if (DialogProps.TransitionProps?.onExited) {
      DialogProps.TransitionProps.onExited(node)
    }
  }

  return (
    <>
      <AdminFormDialog
        formData={user}
        submitCallback={submitCallback}
        onClickDelete={onClickDelete}
        FormComponent={Form}
        DialogProps={{
          ...DialogProps,
          TransitionProps: {
            onExited
          }
        }}
        DialogTitleProps={{
          children: "Edit User"
        }}
      />

      <AdminDeleteDialog
        selected={confirmDelete ? 1 : 0}
        deleteCallback={onConfirmDelete}
        DialogProps={{
          TransitionProps: {
            onExited
          }
        }}
      />
    </>
  )
}

export default UserFormDialog
